import { render, staticRenderFns } from "./ShiftsTemplateEdit.vue?vue&type=template&id=66cb3d23&scoped=true&"
import script from "./ShiftsTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./ShiftsTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsTemplateEdit.vue?vue&type=style&index=0&id=66cb3d23&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cb3d23",
  null
  
)

export default component.exports